<template>
  <div class="categories">
    <div :class="{ 'px-4': !form }">
      <p v-if="!form" class="text-tooltip text-tooltip--info">
        <span>{{ $t(`${namespace}.tooltipWebCallTitle`) }}</span>&nbsp;
        <v-tooltip min-width="177" max-width="177" top>
          <v-icon color="accent" slot="activator">error_outline</v-icon>
          <span>{{ $t(`${namespace}.tooltipWebCallCategories`) }}</span>
        </v-tooltip>
      </p>

      <ul
        class="categories__list"
        :class="{ 'categories__list--error': required && !categoryIds.length }"
      >
        <!-- tip: 对品类有特殊处理 此处不显示poupa99，不知道什么背景-->
        <li
          v-for="(category, index) in $store.state.commonConfig.categories"
          :key="index"
          :id="`category__item--${category.value}`"
          v-show="category && category.value !== 'poupa99'"
          class="category__item"
        >
          <label>
            <v-layout style="min-height: 64px" align-center justify-center row wrap>
              <v-flex sm10 xs8>
                <v-layout align-center row wrap>
                  <v-flex sm2 xs6>
                    <img class="category__img" :src="category.img" alt="">
                  </v-flex>

                  <v-flex sm2 xs6>
                    <span class="category__name">{{ category.text }}</span>
                  </v-flex>

                  <v-flex sm8 xs12>
                    <span class="category__desc pl-2">{{ category.description }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-spacer />

              <v-flex sm1 xs2>
                <v-switch
                  v-model="categoryIds"
                  :value="category.value"
                  class="category__switch pa-0 ma-0"
                  color="success"
                  hide-details
                  @change="getCategoriesList"
                />
              </v-flex>
            </v-layout>
          </label>
        </li>
      </ul>
    </div>

    <div
      v-if="required && !categoryIds.length"
      class="categories__error"
      :class="{ 'px-4': !form }"
    >
      {{ $t(`${namespace}.webCallCategoriesError`) }}
    </div>
  </div>
</template>

<script>
import { objectToArray } from 'utils/functions'

export default {
  name: 'CarCategoriesList',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    form: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Components.ApplyToAllDialog',
      categoryIds: []
    }
  },
  methods: {
    getCategoryData (category) {
      if (!category) return
      /* todo: ridesCategoriesList */
      return objectToArray(this.$store.state.commonConfig.categories).find(item => item.value === category)
    },

    getCategoriesList (categories) {
      document.querySelectorAll('.category__item').forEach(element => {
        element.classList.remove('category__item--active')
      })

      categories.forEach(cat => {
        const elem = document.getElementById(`category__item--${cat}`)
        if (elem) elem.classList.add('category__item--active')
      })

      this.$emit('getCategoriesList', this.categoryIds)
    }
  },
  watch: {
    categoryIds (val) {
      this.$emit('getCategoriesList', val)
    }
  },
  created () {
    this.categoryIds = [ ...this.categories ]
  },
  mounted () {
    this.getCategoriesList(this.categories)
  }
}
</script>

<style lang="scss">
.categories {
  position: relative;
}

.categories__list {
  list-style-type: none;
  padding: 0;
}

.category__item {
  border: solid 1px #f0f0f0;
  margin-bottom: 8px;
  padding: 8px 16px;
  transition: border .26s;

  @media (min-width: 600px) {
    padding-bottom: 0;
    padding-top: 0;
  }

  label {
    cursor: pointer;
  }

  &.category__item--active {
    background-color: #fffadd;
  }
}

.category__img {
  transform: translateY(3px);
  margin-bottom: 8px;
  min-width: 70px;
  max-width: 70px;

  @media (min-width: 600px) {
    margin-bottom: 0;
  }
}

.category__name,
.category__desc {
  display: inline-block;
  line-height: normal;
  transition: border .26s;
}

.category__name {
  font-weight: 600;
  margin-left: 16px;

  @media (min-width: 600px) {
    margin-left: 8px;
  }
}

.category__desc {
  font-size: 12px;
  margin-left: 16px;
}

.categories__list--error {

  .category__item {
    border-color: $error;
  }

  .category__name,
  .category__desc {
    color: $error;
  }
}

.categories__error {
  color: $error;
  font-size: 12px;
  left: 0;
  margin-top: 4px;
  position: absolute;
  right: 0;
  top: 100%;
}
</style>
